import { render, staticRenderFns } from "./WelcomeGradePicker.vue?vue&type=template&id=a23d7486"
import script from "./WelcomeGradePicker.vue?vue&type=script&lang=js"
export * from "./WelcomeGradePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports